RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _) {
    'use strict';

    views.DualGraphLegendItem = Marionette.ItemView.extend({
        ui: {
            bar: '.x-dual-graph-legend-item-color div'
        },
        className: 'x-dual-graph-legend-item',
        template: '#dualGraphLegendItemTemplate',
        onRender: function () {
            const me = this;
            const el = me.ui.bar;
            const model = me.model;

            const color = model.get('color');

            if (typeof color === 'function') {
                el.css('background-color', color(model));
            } else if (color) {
                el.css('background-color', color);
            }

            if (model.get('class')) {
                el.addClass(model.get('class'));
            }

            const legendItemClassName = model.get('legendItemClassName');
            if (legendItemClassName) {
                me.$el.addClass(legendItemClassName);
            }

            const id = model.get('id');
            if (id) {
                me.$el.data('id', id);
            }
        }
    });
});
